/*
  LUXURIA – PayPal „Später Bezahlen“-Hinweis
  - nutzt ausschließlich das offizielle PayPal Pay Later Messaging (SDK-Namespace „PayPalSDK“, siehe layout/theme.liquid)
  - PayPal entscheidet selbst, welches Angebot zum Betrag angezeigt wird (keine eigene Raten-/Zinsberechnung)
  - Betrag: 1. aktueller APO-Gesamtpreis (.mws-subtotal-price), 2. Preis der gewählten Variante, 3. Produktpreis
  - genau EIN Hinweis direkt unter dem Warenkorb-Bereich; bei Preisänderung wird derselbe Container neu gerendert
  - ohne gültigen Betrag (> 0 €) wird kein Hinweis gezeigt
*/
(function () {
  'use strict';
  if (window.luxPayLaterStarted) return;
  window.luxPayLaterStarted = true;

  var cfg = window.luxPayLater || {};

  function parseMoney(text) {
    var raw = (text || '').replace(/[^\d,.]/g, '');
    if (!raw) return null;
    var n = parseFloat(raw.replace(/\./g, '').replace(',', '.'));
    return isNaN(n) || n <= 0 ? null : n;
  }

  function variantAmount(form) {
    var input = form && form.querySelector('[name="id"]');
    var cents = input && cfg.variants ? cfg.variants[String(input.value)] : null;
    return cents > 0 ? cents / 100 : null;
  }

  function currentAmount(info, form) {
    var t = info.querySelector('.mws-price .mws-subtotal-price span:last-child');
    var n = t ? parseMoney(t.textContent) : null;
    if (n) return n;
    n = variantAmount(form);
    if (n) return n;
    return cfg.price > 0 ? cfg.price / 100 : null;
  }

  function start() {
    var info = document.querySelector('.product-info');
    if (!info || info.querySelector('.lux-paylater')) return;
    var actions = info.querySelector('.product-actions');
    if (!actions || !actions.parentNode) return;
    var form = actions.closest('form');

    var box = document.createElement('div');
    box.className = 'lux-paylater';
    var msg = document.createElement('div');
    msg.setAttribute('data-pp-message', '');
    msg.setAttribute('data-pp-placement', 'product');
    msg.setAttribute('data-pp-style-layout', 'text');
    msg.setAttribute('data-pp-style-logo-type', 'inline');
    msg.setAttribute('data-pp-style-text-color', 'black');
    box.appendChild(msg);
    actions.parentNode.insertBefore(box, actions.nextSibling);

    var shown = null;
    var render = function () {
      var amount = currentAmount(info, form);
      box.hidden = !amount;
      if (!amount) return;
      var value = amount.toFixed(2);
      if (value === shown) return;
      shown = value;
      msg.setAttribute('data-pp-amount', value);
      var sdk = window.PayPalSDK;
      if (sdk && sdk.Messages) {
        sdk.Messages({ amount: amount }).render(msg).catch(function () {});
      }
    };

    var timer = null;
    var schedule = function () {
      clearTimeout(timer);
      timer = setTimeout(render, 300);
    };
    // APO aktualisiert den Gesamtpreis, das Theme den Variantenpreis; Änderungen im eigenen Hinweis werden ignoriert
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (!box.contains(records[i].target)) { schedule(); return; }
      }
    }).observe(info, { subtree: true, childList: true, characterData: true });
    info.addEventListener('change', schedule, true);

    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
